<template>
  <p>{{$t('platformSettings')}}</p>
</template>